export class MessageCto {
  text: string
  imageContent: Array<{}>
  isimage: boolean
  isfile: boolean
  fileContent: string
  fileSize: string
  userId: number
  chatId: number
}
